import { Component, Injector } from '@angular/core';

import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'md-welcome-back',
  template: require('./welcome-back.component.html'),
  styles: [require('./welcome-back.component.scss')]
})
export class WelcomeBackComponent extends BaseRoute {

  values = {};

  // eslint-disable-next-line no-useless-constructor
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.appActions.setData('stepUserIsOn', 0);
  }

  btnClick(event) {
    if (!this.isSubmitting) {
      this.isSubmitting = true;
      this.form.buttons.inputs.next.classes += ' spinner';
      this.form.buttons.inputs.next.disabled = true;
      this.appProxy.getLookup(this.values, resp => {
        this.isSubmitting = false;
        this.form.buttons.inputs.next.classes = this.form.buttons.inputs.next.classes.replace(' spinner', '');
        this.form.buttons.inputs.next.disabled = false;

        if (resp.error) {
          this.flowManager.pageError = { hasErrors: true, message: 'There was an error getting your application.' };
        } else if (resp.code) { // Invalid application number or access code
          this.flowManager.pageError = { hasErrors: true, errorCount: 1 };
          this.appActions.setData('welcomeBack.applicationNumber_invalid', resp.detail.includes('application'));
          this.appActions.setData('welcomeBack.accessCode_invalid', resp.detail.includes('access'));
          this.validation.validateForm();
        } else {
          this.appActions.setData('DocumentUploader.id', resp.id);
          this.router.navigate(['document-uploader'], { queryParamsHandling: 'preserve' });
        }
      });
    }
  }

  updateOptionValue(event) {
    this.values[event.id] = event.value;
  }

}
